import { Row } from "antd";
import { Route, Switch } from "react-router-dom";
import AdminCasebank from "./Casebank/Casebank";
import AdminArticles from "./Articles/Articles";
import AdminPublications from "./Publications/Publications";
import { CreateCase, EditCase } from "./Casebank/CreateOrEditCase";
import SelectCompanyForNewCase from "./Casebank/SelectCompanyForNewCase";

const AdminResources = () => {
  return (
    <>
      <Row gutter={[0, 48]}>
        <Switch>
          <Route exact path="/admin/resources/casebank/" component={AdminCasebank} />
          <Route path="/admin/resources/casebank/edit/:id/" component={EditCase} />
          <Route exact path="/admin/resources/casebank/new/" component={SelectCompanyForNewCase} />
          <Route path="/admin/resources/casebank/new/:id/" component={CreateCase} />
          <Route path="/admin/resources/articles/" component={AdminArticles} />
          <Route path="/admin/resources/publications/" component={AdminPublications} />
        </Switch>
      </Row>
    </>
  );
};

export default AdminResources;
